<template>
  <div :class="['tracker-table-container', programStyle]">
    <div class="tracker-header">
      <div class="title">{{ $t('trackers') }}</div>
      <button
        v-if="showCollapseButton && showCollapse && trackerInfo.length > 1"
        class="small-btn"
        @click="collapseAll(trackerInfo)"
      >
        {{ $t('collapse-all') }}
      </button>
      <button
        v-if="showCollapseButton && !showCollapse && trackerInfo.length > 1"
        class="small-btn"
        @click="expandAll(trackerInfo)"
      >
        {{ $t('expand-all') }}
      </button>
    </div>
    <div class="tracker" v-for="(tracker, index) in trackerInfo" :key="`row-${index}`">
      <div class="section-header" @click="toggleTracker(tracker)">
        <div class="section">
          <div :class="['circle', tracker.trackerDialColor]" v-if="tracker.trackerId !== 'Wgnr Fac'"></div>
          <div class="icon-progress" v-if="tracker.trackerId === 'Wgnr Fac'">
            <IconProgress
              v-if="tracker.trackerDialProgress"
              :progress="tracker.trackerDialProgress"
              :targets="3"
              :color="tracker.trackerDialColor"
            />
          </div>
          {{ tracker.trackerTitle }}
        </div>
        <Carrot v-if="tracker.show !== null" :class="tracker.show ? 'carrot-flipped' : 'carrot'" />
      </div>
      <div class="tracker-content" v-if="tracker.show">
        <div class="tracker-status">
          <div>{{ tracker.trackerStatus }}</div>
        </div>
        <div class="section-small">
          <div>{{ tracker.messageTop1 }}</div>
        </div>
        <div class="id-container" v-if="tracker.trackerId === 'Id Stds'">
          <div :class="['id-box', tracker.trackerDialColor]">
            <span> {{ tracker.resultText }}</span>
          </div>
          <div class="id-info">
            <span class="label"
              >{{ $t('order-received') }}
              <span class="light">{{ tracker.orderReceived === 'Yes' ? 'Yes' : 'No' }} </span></span
            >
            <span class="label"
              >Deposit: <span class="light">{{ tracker.display === 'Yes' ? 'Yes' : 'No' }} </span></span
            >
            <span class="label"
              >NVD: <span class="light">{{ tracker.nvd === 'Yes' ? 'Yes' : 'No' }} </span></span
            >
          </div>
        </div>
        <div class="id-container" v-if="tracker.trackerId === 'Wgnr Fac'">
          <div :class="['id-box', tracker.survey.designSurveyColor]" v-if="tracker.survey">
            <span> {{ tracker.survey.label }}</span>
            <span class="strikes">{{ tracker.survey.value }}</span>
          </div>
          <div :class="['id-box', tracker.firstSite.firstSiteApprovalColor]" v-if="tracker.firstSite">
            <span>{{ tracker.firstSite.label }}</span>
            <span class="strikes"> {{ tracker.firstSite.value }}</span>
          </div>
          <div :class="['id-box', tracker.approved.approvedColor]" v-if="tracker.approved">
            <span> {{ tracker.approved.label }}</span>
            <span class="strikes">{{ tracker.approved.value }} </span>
          </div>
        </div>
        <div class="id-container" v-if="tracker.trackerId === 'Mrkt Spprt'">
          <div
            :class="['id-box', strike.color, 'market-grid']"
            v-for="(strike, index) in tracker.strikes"
            :key="`row-${index}`"
          >
            <span> {{ strike.labelName }} </span>
            <span class="strikes">{{ $t('strikes', [strike.value]) }}</span>
          </div>
        </div>
        <div class="section-small">
          <div>{{ tracker.dealerMessageBottom }}</div>
        </div>
        <div class="section-small">
          <div>{{ tracker.messageBottom1 }}</div>
          <div>{{ tracker.messageBottom2 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carrot from '@/assets/icons/carrot_up.svg';
import IconProgress from '@/components/IconProgress.vue';
import { mapState } from 'vuex';

export default {
  name: 'Tracker',
  components: {
    Carrot,
    IconProgress,
  },
  props: {
    trackerInfo: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState('global', ['programStyle']),
    showCollapse() {
      if (this.trackerInfo) {
        const isEven = this.trackerInfo.every((tracker) => tracker.show);
        return isEven;
      }
      return false;
    },
    showCollapseButton() {
      if (this.trackerInfo) {
        return this.trackerInfo.some((tracker) => tracker.show !== null);
      }
      return false;
    },
  },
  watch: {},
  methods: {
    toggleTracker(tracker) {
      if (tracker.show !== null) {
        tracker.show = !tracker.show;
      }
    },
    expandAll(array) {
      array.forEach((tracker) => {
        if (tracker.show !== null) {
          this.$set(tracker, 'show', true);
        }
      });
    },
    collapseAll(array) {
      array.forEach((tracker) => {
        if (tracker.show !== null) {
          this.$set(tracker, 'show', false);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tracker {
  display: flex;
  flex-direction: column;
  width: 100%;

  .validated-icon {
    height: 50px;
    width: 50px;
    filter: drop-shadow(0px 3px 6px #00000029);
  }
}
.tracker-table-container {
  display: flex;
  flex-direction: column;
}
.tables {
  display: flex;
}
.tracker-content {
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  padding-left: 50px;
}
.tracker-status {
  color: #1d1d1b;
  font-size: 18px;
}
.section-title {
  font-size: 21px;
  display: flex;
  padding-left: 10px;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  cursor: pointer;
}
.section {
  font-size: 18px;
  color: #1d1d1b;
  display: flex;
  align-items: center;
}
.section-small {
  color: #1d1d1b;
  font-size: 14px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.section-row {
  color: #1d1d1b;
  font-size: 14px;
  padding-top: 15px;
  display: flex;
}
.section-icons {
  display: flex;
  padding-top: 20px;
  svg {
    height: 35px;
    width: 35px;
    padding-right: 10px;
  }
  .icon-text {
    display: flex;
    align-items: center;
    padding-right: 20px;
    font-size: 12px;
    text-decoration: underline;
    color: #243882;
    cursor: pointer;
  }
  .cx_logo {
    width: 173px;
  }
}
.left-table {
  margin-top: 30px;
}
.right-table {
  margin-left: 10px;
}
.id-container {
  display: flex;
  flex-wrap: wrap;
  .market-grid {
    flex-basis: calc(20% - 20px);
    margin: 10px;
  }
  .id-box {
    width: 150px;
    height: 75px;
    background-color: gray;
    color: White;
    font-weight: 600;
    margin-right: 30px;
    justify-content: center;
    align-content: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    &.P {
      background-color: green;
    }
    span {
      margin: 0 auto;
      text-decoration: underline;
    }
    .strikes {
      margin-top: 6px;
      font-weight: 500;
      text-decoration: none;
    }
  }

  .id-info {
    display: flex;
    flex-direction: column;
    color: black;
    font-weight: 600;
    justify-content: center;
    .light {
      font-weight: 500;
    }
    .label {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
.tracker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icon-progress {
  margin-right: 10px;
}
</style>
